export const ist = {
    MixDiagrammYearIstClass: {
        url: "Diagramm/mixedbar",
        defaultSegment: "Diagramm",
        forceRefresh: false,
        receiveType: 'RECEIVE_MixDiagrammYearIst_istAllYearsReducer'
    }
};